var App = App || {};

App.VerticalComponents = (function ($) {
    "use strict";

    function init() {

        const verticalEventsBand = $(".block.block-verticalcomponents .vertical-eventsband");
        if (verticalEventsBand.length) {
            verticalEventsBand.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(verticalEventsBand) {
        const carousel = verticalEventsBand.find(".splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                direction: 'ttb',
                type: 'loop',
                height: "auto",
                autoHeight: true,
                fixedWidth: "100%",
                gap: "11px",
                drag: true,
                snap: false,
                perMove: 1
            });

            splideCarousel.mount();

            const nextBtn = verticalEventsBand.find(".carousel-btn.carousel-next");
            const prevBtn = verticalEventsBand.find(".carousel-btn.carousel-prev");

            nextBtn.on("click", function () {
                splideCarousel.go('+1')
            });

            prevBtn.on("click", function () {
                splideCarousel.go('-1')
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.VerticalComponents.init();
});